// อ่าน "ปลายทางที่ค้างไว้" ที่ sw.js เขียนลง IndexedDB ตอนกด push notification แล้วไม่มีแท็บแอปเปิดอยู่
// (workaround บั๊ก iOS: clients.openWindow(url) เมิน url แล้วพาไป start_url แทนตอนแอปโดนปิดไปแล้ว)
// ต้องใช้ DB/store/key ชื่อเดียวกับใน public/sw.js

const DB_NAME = 'thaiusinvest-push';
const STORE_NAME = 'pending';
const KEY = 'target';

export interface PendingNotificationTarget {
  id?: string;
  url: string;
  ts?: number;
}

export function readAndClearPendingNotificationTarget(): Promise<PendingNotificationTarget | null> {
  return new Promise((resolve) => {
    if (!('indexedDB' in window)) {
      resolve(null);
      return;
    }
    try {
      const openReq = indexedDB.open(DB_NAME, 1);
      openReq.onupgradeneeded = () => {
        if (!openReq.result.objectStoreNames.contains(STORE_NAME)) {
          openReq.result.createObjectStore(STORE_NAME);
        }
      };
      openReq.onsuccess = () => {
        const db = openReq.result;
        try {
          const tx = db.transaction(STORE_NAME, 'readwrite');
          const store = tx.objectStore(STORE_NAME);
          const getReq = store.get(KEY);
          getReq.onsuccess = () => {
            const value = getReq.result as PendingNotificationTarget | undefined;
            store.delete(KEY);
            tx.oncomplete = () => { db.close(); resolve(value ?? null); };
            tx.onerror = () => { db.close(); resolve(value ?? null); };
          };
          getReq.onerror = () => { db.close(); resolve(null); };
        } catch {
          db.close();
          resolve(null);
        }
      };
      openReq.onerror = () => resolve(null);
    } catch {
      resolve(null);
    }
  });
}
